const base = window.location.href.includes("localhost") ? "http://street_giving.test/":"https://savethechildrenmx.org/"
const event = 3

export const validatePass = (evt)=>{
    var cadena = evt.target.value

    if (cadena.length > 3){
        document.querySelector(".search").classList.remove("disabled")
        document.querySelector(".search").removeAttribute("disabled")
    }else{
        document.querySelector(".search").classList.add("disabled")
        document.querySelector(".search").setAttribute("disabled", "")
    }
}

function formatCurrency(amount) {
    return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
    }).format(amount);
}

const selectSeats = ()=>{
    var asientos = document.getElementById("asientos").value;
    document.querySelectorAll(".table-container.selected .asiento-0").forEach(element =>{
        element.classList.remove("preselect")
    })
    document.querySelectorAll(".table-container.selected .asiento-0").forEach((element,index) =>{
        if (index < asientos){
            element.classList.add("preselect")
        }
    })
}

export const start = ()=>{
    document.querySelector(".image-container").classList.add("hide");
    document.querySelector(".step-1").classList.remove("hide");
    document.querySelector(".search").classList.add("disabled");
    document.querySelector(".search").setAttribute("disabled", "");
}

export const showMap = ()=>{
    document.querySelector(".step-1").classList.add("hide");
    document.querySelector(".step-2").classList.remove("hide");

}

export const decrementarAsientos = ()=>{
    if (document.querySelector(".cantidad").textContent > 1){
        document.querySelector(".cantidad").textContent = Number(document.querySelector(".cantidad").textContent) - 1;
        document.querySelector("#asientos").value = document.querySelector(".cantidad").textContent;
    }
    document.querySelector(".total").textContent = formatCurrency(document.querySelector(".cantidad").textContent * document.querySelector("#precio").value);
    document.querySelector("#total").value = document.querySelector(".cantidad").textContent * document.querySelector("#precio").value;

    selectSeats()
}

export const incrementarAsientos = () =>{
    if (document.querySelector(".cantidad").textContent < document.querySelectorAll(".table-container.selected .asiento-0").length){
        document.querySelector(".cantidad").textContent = Number(document.querySelector(".cantidad").textContent) + 1;
        document.querySelector("#asientos").value = document.querySelector(".cantidad").textContent;
    }
    document.querySelector(".total").textContent = formatCurrency(document.querySelector(".cantidad").textContent * document.querySelector("#precio").value);
    document.querySelector("#total").value = document.querySelector(".cantidad").textContent * document.querySelector("#precio").value;

    selectSeats()
}

export const continueToContactDatas = (evt)=>{
    evt.target.classList.add("disabled")
    evt.target.setAttribute("disabled", "");
    evt.target.textContent = "Un momento por favor"
    var contraseña = document.getElementById("contraseña").value.length > 0 ? document.getElementById("contraseña").value : "nopwd"
    fetch(base+"api/events/table/"+document.getElementById("mesa").value+"/seats/"+document.getElementById("asientos").value+"/status/"+document.getElementById("status").value+"/"+contraseña+"/preselect",{
        method:"GET"
    }).then(res => res.json()).then(data => {
        if(data.length > 0){
            var seats = ""
            data.forEach((seat,index)=>{
                if (index === 0){
                    seats = seat.id
                }else{
                    seats += ","+seat.id
                }
            })
            document.querySelector("#asientos_apartados").value = seats

            localStorage.setItem("seats",JSON.stringify(data))
            document.querySelector(".step-2").classList.add("hide");
            document.querySelector(".step-3").classList.remove("hide");
        }else{

            document.querySelector("#table-without-seats").showModal()

            /*
            * @TODO hacer accion para volver al mapa y seleccionar otra mesa
            * @TODO refrescar el mapa cada minuto o cuando exista un error
            * */
        }

    })
}

export const makeContact = (evt)=>{
    evt.target.classList.add("disabled")
    evt.target.setAttribute("disabled", "");
    evt.target.textContent = "Un momento por favor"
    var values = {}

    document.querySelectorAll(".step-2 input,.step-3 input").forEach(element => {
        values[element.id] = element.value;
    })


    fetch(base+"api/events/"+event+"/contact/create?data="+btoa(JSON.stringify(values)),{
        method:"GET",
    }).then(res => res.json()).then(data => {

        if (data.locked){
            alert("Debido al mal uso de la plataforma, hemos bloqueado tu acceso a la misma.")
            window.location.reload();
        }
        localStorage.setItem("contact",JSON.stringify(data))

        document.querySelector(".step-2").classList.remove("header-height");
        document.querySelector(".step-2").classList.add("hide");
        document.querySelector(".step-3").classList.remove("form-height");
        document.querySelector(".step-3").classList.add("hide");
        document.querySelector(".step-4").classList.remove("hide");
        document.querySelector(".step-4").classList.add("full-height");

        document.querySelector("#contact").value = data.contact;
        document.querySelector("#deal").value = data.deal;
        document.querySelector("#new").value = data.new;
    })
}

export const makePayment = (evt)=>{
    evt.target.classList.add("disabled")
    evt.target.setAttribute("disabled", "");
    evt.target.textContent = "Un momento por favor"
    var values = {}

    document.querySelectorAll(".step-2 input,.step-3 input,.step-4 input").forEach(element => {
        values[element.id] = element.value;
    })


    fetch(base+"api/events/"+event+"/payment/create?data="+btoa(JSON.stringify(values)),{
        method:"GET",
    }).then(res => res.json()).then(data => {
        if (data.status.localeCompare("succeeded") === 0){
            document.querySelector(".step-4").classList.add("hide");
            document.querySelector(".step-5").classList.remove("hide");
            document.querySelector(".google-calendar").href = "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20260430T010000Z%2F20260430T040000Z&details=Cena%20en%20Rojo%202026&location=https%3A%2F%2Fwww.google.com%2Fmaps%2Fplace%2FPapalote%2BMuseo%2Bdel%2BNi%25C3%25B1o%2F%4019.4117058%2C-99.1975965%2C17z%2Fdata%3D%213m1&text=Cena%20en%20Rojo%202026"
            document.querySelector(".i-calendar").href = "https://icalendar.cenaenrojo.mx/calendar.php?id="+data.payment_id.id
        }else{
            if (data.status.localeCompare("error") === 0){
                alert("Error en el intento de pago: " + (data.reason ? data.reason : data.error));
                evt.target.classList.remove("disabled")
                evt.target.removeAttribute("disabled");
                evt.target.textContent = "Pagar"
            }else{
                document.querySelector("#secure-dialog").showModal()
                window.open(data.authorization_url)
                document.querySelector("#payment_intent").value = data.id
            }
        }
    })
}

export const  llenarInputsUTM = () => {
    const params = new URLSearchParams(window.location.search);


    // Recorrer todos los parámetros UTM
    params.forEach((valor, clave) => {
        if (clave.startsWith("utm_")) {
            const input = document.querySelector(`input[name="${clave}"]`);
            if (input) {
                input.value = valor;
            }
        }
    });
}

export const closeModal = (evt) => {
    evt.target.parentElement.parentElement.close();
}


export const handleFocus = (evt) => {
    evt.target.parentElement.classList.add("focus");
}

export const handleBlur = (evt) => {
    if (evt.target.value.length === 0){
        evt.target.parentElement.classList.remove("focus");
    }
}

export const unlockButton = (element) => {
    var input = element
    var flag = true

    while(!input.classList.contains("step")){
        input = input.parentElement;
    }

    input.querySelectorAll(".form-group").forEach(element => {
        if (!element.classList.contains("is-valid")){
            flag = false
        }
    })


    if (flag){
        input.querySelector("button.continue").classList.remove("disabled")
        input.querySelector("button.continue").removeAttribute("disabled")
    }else{
        input.querySelector("button.continue").classList.add("disabled")
        input.querySelector("button.continue").setAttribute("disabled","disabled")
    }

}

const validateName = (name) =>{
    var regex = new RegExp("^[A-Za-záéíóúñÁÉÍÓÚÑ]{3,}( [A-Za-záéíóúñÁÉÍÓÚÑ]{3,})*$");

    if (regex.test(name.value)){
        name.parentElement.classList.add("is-valid");
        name.parentElement.classList.remove("is-invalid");
    }else{
        name.parentElement.classList.add("is-invalid");
        name.parentElement.classList.remove("is-valid");
    }

    unlockButton(name)
}

const validateEmail = (email) =>{
    var regex = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");
    if (regex.test(email.value)){
        email.parentElement.classList.add("is-valid");
        email.parentElement.classList.remove("is-invalid");
    }else{
        email.parentElement.classList.add("is-invalid");
        email.parentElement.classList.remove("is-valid");
    }

    unlockButton(email)
}

const validatePhone = (phone) =>{
    var regex = new RegExp("^[0-9]{10}$");
    if (regex.test(phone.value)){
        phone.parentElement.classList.add("is-valid");
        phone.parentElement.classList.remove("is-invalid");
    }else{
        phone.parentElement.classList.add("is-invalid");
        phone.parentElement.classList.remove("is-valid");
    }

    unlockButton(phone)
}

export const validateTarjeta = (tarjeta) =>{
    var regex = new RegExp("^[0-9]{15,16}$");
    if (regex.test(tarjeta.value)){
        tarjeta.parentElement.classList.add("is-valid");
        tarjeta.parentElement.classList.remove("is-invalid");
    }else{
        tarjeta.parentElement.classList.add("is-invalid");
        tarjeta.parentElement.classList.remove("is-valid");
    }

    unlockButton(tarjeta)
}

export const validateMesVencimiento = (vencimiento) =>{
    var regex = new RegExp("^(0[1-9]|1[0-2])$");
    if (regex.test(vencimiento.value)){
        vencimiento.parentElement.classList.add("is-valid");
        vencimiento.parentElement.classList.remove("is-invalid");
    }else{
        vencimiento.parentElement.classList.add("is-invalid");
        vencimiento.parentElement.classList.remove("is-valid");
    }

    unlockButton(vencimiento)
}

export const validateAñoVencimiento = (vencimiento) =>{
    var regex = new RegExp("^(2[5-9]|[3-9][0-9])$");

    if (regex.test(vencimiento.value)){
        vencimiento.parentElement.classList.add("is-valid");
        vencimiento.parentElement.classList.remove("is-invalid");
    }else{
        vencimiento.parentElement.classList.add("is-invalid");
        vencimiento.parentElement.classList.remove("is-valid");
    }

    unlockButton(vencimiento)
}

export const validateCVV = (cvv) =>{
    var regex = new RegExp("^[0-9]{3,4}$");

    if (regex.test(cvv.value)){
        cvv.parentElement.classList.add("is-valid");
        cvv.parentElement.classList.remove("is-invalid");
    }else{
        cvv.parentElement.classList.add("is-invalid");
        cvv.parentElement.classList.remove("is-valid");
    }

    unlockButton(cvv)
}

export const validateCP = (cp) =>{
    var regex = new RegExp("^[0-9]{5}$");

    if (regex.test(cp.value)){
        cp.parentElement.classList.add("is-valid");
        cp.parentElement.classList.remove("is-invalid");
    }else{
        cp.parentElement.classList.add("is-invalid");
        cp.parentElement.classList.remove("is-valid");
    }

    unlockButton(cp)
}

const validateRazonSocial = (razonSocial) =>{
    var regex = new RegExp("^[A-Za-záéíóúñÁÉÍÓÚÑ&]{1,}( [A-Za-záéíóúñÁÉÍÓÚÑ&]{1,})*$");

    if (regex.test(razonSocial.value)){
        razonSocial.parentElement.classList.add("is-valid");
        razonSocial.parentElement.classList.remove("is-invalid");
    }else{
        razonSocial.parentElement.classList.add("is-invalid");
        razonSocial.parentElement.classList.remove("is-valid");
    }

    unlockButton(razonSocial)
}

export const validateRFC = (rfc)=>{
    var regex = new RegExp("^([A-ZÑ]{3,4})\\d{6}([A-Z\\d]{2,3})$");

    if (regex.test(rfc.value)){
        rfc.parentElement.classList.add("is-valid");
        rfc.parentElement.classList.remove("is-invalid");
    }else{
        rfc.parentElement.classList.add("is-invalid");
        rfc.parentElement.classList.remove("is-valid");
    }

    unlockButton(rfc)
}

export const handleKeyUp = (evt) => {
    var element = evt.target

    switch(element.id){
        case "firstName":
            validateName(element)
            break;
        case "lastName":
            validateName(element)
            break;
        case "titular":
            validateName(element)
            break;
        case "email":
            validateEmail(element)
            break;
        case "email-facturacion":
            validateEmail(element)
            break;
        case "phone":
            validatePhone(element)
            break;
        case "tarjeta":
            validateTarjeta(element)
            break;
        case "mes":
            validateMesVencimiento(element)
            break;
        case "year":
            validateAñoVencimiento(element)
            break;
        case "cvv":
            validateCVV(element)
            break
        case "razon_social":
            element.value = element.value.toUpperCase()
            validateRazonSocial(element)
            break
        case "rfc":
            element.value = element.value.toUpperCase()
            validateRFC(element)
            break;
        case "cp_fiscal":
            validateCP(element)
            break

        default:
            alert("error")
            break;
    }
}


export const refresh = () =>{
    window.location.reload()
}


export const validatePayment = ()=>{
    var values = {}

    document.querySelectorAll(".step-2 input,.step-3 input,.step-4 input,.step-5 input, .step-5 select").forEach(element => {
        values[element.id] = element.value;
    })

    fetch(base+"api/events/payments/validate?data="+btoa(JSON.stringify(values)),{
        method: 'GET',
    }).then(response => response.json()).then(data => {
        if (data.status.localeCompare("succeeded") === 0){
            document.querySelector(".step-4").classList.add("hide");
            document.querySelector(".step-5").classList.remove("hide");
        }else{
            if (data.status.localeCompare("error") === 0){
                alert("Error en el intento de pago: " + (data.reason ? data.reason : data.error));
            }
        }

        document.querySelector("#secure-dialog").close()
    })
}

export const enviarFactura = ()=>{
    var values = {}

    document.querySelectorAll(".step-2 input,.step-3 input,.step-4 input,.step-5 input, .step-5 select").forEach(element => {
        values[element.id] = element.value;
    })



    fetch(base+"api/events/payments/invoice?data="+btoa(JSON.stringify(values)),{
        method: 'GET',
    }).then(response => response.json()).then(data => {
        window.location.href = "https://apoyo.savethechildren.mx/gracias-cenas"
    })
}

export const backToMap = (evt)=>{
    document.querySelector(".step-2").classList.remove("selected")
    document.querySelector(".full").classList.remove("full");
    document.querySelectorAll(".hide-section").forEach(element=>{
        element.classList.remove("hide-section")
    })

    document.querySelectorAll(".section.d-none").forEach(element=>{
        element.classList.remove("d-none")
    })

    if (document.querySelector(".obj")){
        document.querySelector(".obj").classList.remove("d-none")
        document.querySelector(".obj").style.opacity = 1
    }
    document.querySelector(".table-container.selected").classList.remove("selected")

    document.querySelectorAll(".not-selected").forEach(element=>{
        element.classList.remove("not-selected")
        element.classList.remove("d-none")
    })
    document.querySelectorAll(".asiento.preselect").forEach(element=>{
        element.classList.remove("preselect")
    })

    document.getElementById("asientos").value = "1"
    document.querySelector(".cantidad").textContent = 1
}